<template>
	<ServiceLogConfig :showConfigPopup="true"></ServiceLogConfig>
</template>

<script>
import ServiceLogConfig from "../widgets/ServiceLogConfig";

export default {
	name: "dashboardServiceLog",
	components: {
		ServiceLogConfig
	},
	data() {
		return {

		}
	},

}
</script>

<style scoped>

</style>